module.exports = __webpack_public_path__ + "static/media/apartmentLink.47548289.svg";